import React from "react";
import { useLocation } from "react-router-dom";
import { MediaQuery } from "@outplayed/responsive";
import AdBoxWrapper from "components/common/Ads/AdBoxWrapper";
import { RampUnit, TagBasedAdUnits } from "@outplayed/ramp";

import styles from "stylesheets/variables.module.scss";

const ChampionSideColumn = (props) => {
  const location = useLocation();

  return (
    <div className="champion-page_side-column pw-side-column">
      <MediaQuery at="DESKTOP_LARGE" isClient renderNullOnFail>
        <AdBoxWrapper adStyles={{ display: "flex", alignItems: "center", justifyContent: "center" }} width={300} height={250}>
          <RampUnit
            type={TagBasedAdUnits.MediumRectATF}
            id="champion-side-med-rect-atf-1"
            pathname={location.pathname}
            search={location.search}
          />
        </AdBoxWrapper>
      </MediaQuery>
      <MediaQuery at="DESKTOP_LARGE" isClient renderNullOnFail>
        <AdBoxWrapper
          styles={{ position: "sticky", top: `calc(12px + ${styles.mastheadHeight})` }}
          adStyles={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          minAdWidth={300}
          minAdHeight={250}
        >
          <RampUnit
            type={TagBasedAdUnits.MediumRectBTF}
            id="champion-side-med-rect-btf-1"
            pathname={location.pathname}
            search={location.search}
          />
        </AdBoxWrapper>
      </MediaQuery>
    </div>
  );
};

export default ChampionSideColumn;
